(function() {

angular.module('ngmvac').
directive('fadeIn', function($timeout) {
    return {
        restrict: 'A',
        scope:{
            anim:"=animval",
            images:"="
        },
        link: function($scope, $element, attrs){
            $element.on('load', function() {
            	$element.addClass("ng-hide-add").removeClass("ng-hide-remove");
        		$scope.$apply(function(){
        			$scope.$parent.hotel.loadGaleria = 0;
        		});
                $scope.$parent.sliderLoaded = true;
            });

            $element.on('error', function() {
                console.log(attrs.ngSrc);
                for( var index = 0; index < $scope.images.length; index++ ) {
                    var pattern = new RegExp('\\w*' + $scope.images[index].replace('\\', '') + '$');
                    if( pattern.test(attrs.ngSrc) ) {
                        $scope.images.splice(index, 1);
                        $scope.$apply(function() {
                            $scope.$parent.$parent.hotel.fotoActual = (index < $scope.images.length) ? $scope.images[index] : $scope.images[0];
                            console.log($scope.images);
                        });
                    }
                }
                if( $scope.images.length == 0 ) {
                    $scope.$parent.sliderLoaded = true;
                }
                console.log($scope.$parent);
            });

            $scope.$watch(
				function() {
					return $scope.anim
				},
				function(value) {
					if( value == 1 ) {
						$element.addClass("ng-hide-remove").removeClass("ng-hide-add");
					}
				}
			);
        }
    };
});

})();
